var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100 p-3"},[(_vm.record !== null)?_c('b-overlay',{attrs:{"opacity":_vm.overlay.opacity,"show":_vm.overlay.visible,"rounded":"sm"}},[_c('form-profile'),_c('b-button',{on:{"click":function($event){return _vm.baseUpdate()}}},[_vm._v("Save")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }